import React from 'react';

export function StepSubjectAndOvzLabel() {
  return <>Výběr Provozovatele a Provozovny</>;
}
